import { ApiProperty } from "@nestjs/swagger";

export class ItemCodeRequest{
    @ApiProperty()
    itemCode:string;
    @ApiProperty()
    unitId:number;
}